import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const includedFeatures = ['Diseño High-End optimizado para iPhone & Android.', 'Botón de Ventas directo a tu WhatsApp.', 'Posicionamiento Local en Google Maps.', 'Velocidad de Carga Instantánea (Cero Esperas).', 'Tu propio Dominio .com y Hosting Seguro.', 'Asesoría Estratégica 1-a-1 en Chicago.'];
export function PricingCard() {
  return <section className="py-24 md:py-32 bg-brand-charcoal relative border-y border-brand-gold/10" data-id="element-79">
      {/* Decorative gold line top */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-[1px] bg-gradient-gold" data-id="element-80"></div>

      <div className="max-w-4xl mx-auto px-4 flex flex-col items-center" data-id="element-81">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-82">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-83">
            Inversión Transparente
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-84">
            Sin cuotas ocultas. Un solo pago para transformar tu presencia
            digital.
          </p>
        </motion.div>

        <motion.div className="w-full max-w-lg bg-brand-black rounded-3xl p-8 md:p-12 border border-brand-gold shadow-[0_0_40px_rgba(212,175,55,0.1)] relative overflow-hidden" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} data-id="element-85">
          {/* Subtle glow inside card */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-32 bg-brand-gold/5 blur-3xl pointer-events-none" data-id="element-86"></div>

          <div className="text-center mb-8 relative z-10" data-id="element-87">
            <h3 className="text-brand-gold font-heading font-bold tracking-widest uppercase text-base mb-4" data-id="element-88">
              OFERTA DE LANZAMIENTO
            </h3>
            <div className="flex flex-col items-center justify-center mb-2" data-id="element-89">
              <span className="text-gray-500 text-sm line-through mb-1" data-id="element-90">
                Regular $595
              </span>
              <div className="flex items-baseline gap-2" data-id="element-91">
                <span className="text-6xl md:text-7xl font-black font-heading" style={{
                textShadow: '0 0 30px rgba(212,175,55,0.3)'
              }} data-id="element-92">
                  $295
                </span>
                <span className="text-xl text-gray-400 font-heading" data-id="element-93">USD</span>
              </div>
            </div>
            <p className="text-gray-400 font-medium" data-id="element-94">
              (Pago Único - Sin cargos ocultos)
            </p>
          </div>

          <div className="space-y-4 mb-8 relative z-10" data-id="element-95">
            {includedFeatures.map(feature => <div key={feature} className="flex items-start gap-3" data-id="element-96">
                <Check className="w-5 h-5 text-brand-gold shrink-0 mt-0.5" data-id="element-97" />
                <span className="text-gray-300 font-body" data-id="element-98">{feature}</span>
              </div>)}
          </div>

          <div className="text-center mb-6 relative z-10" data-id="element-99">
            <p className="text-brand-gold text-sm font-bold py-4" data-id="element-100">
              📢 EXCLUSIVO: Solo quedan 3 de 5 cupos disponibles para Marzo.
            </p>
          </div>

          <motion.a href="https://wa.me/447311754270" target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-gold text-brand-black font-black text-xl py-5 rounded-xl text-center shadow-[0_4px_20px_rgba(212,175,55,0.4)] hover:shadow-[0_6px_30px_rgba(212,175,55,0.6)] transition-all duration-300 relative z-10" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} data-id="element-101">
            RECLAMAR MI DEMO GRATIS 🚀
          </motion.a>
        </motion.div>
      </div>
    </section>;
}